class ExampleSection {
  constructor(element) {
    this.element = element;
    this.init();
  }
  init() {
    console.log("SECTION EXAMPLE INIT");
  }
}
const exampleSection = {
  init() {
    const exampleElements = document.querySelectorAll('[data-section="example"]');
    if (null !== exampleElements && exampleElements.length > 0) {
      exampleElements.forEach((element) => {
        new ExampleSection(element);
      });
    }
  }
};
document.addEventListener("DOMContentLoaded", () => {
  exampleSection.init();
});
